import { render, staticRenderFns } from "./RoomGroupsList.vue?vue&type=template&id=60492174&scoped=true"
import script from "./RoomGroupsList.vue?vue&type=script&lang=js"
export * from "./RoomGroupsList.vue?vue&type=script&lang=js"
import style0 from "./RoomGroupsList.vue?vue&type=style&index=0&id=60492174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60492174",
  null
  
)

export default component.exports